export default {
    methods:{
        performAutoLogin: function(token, path = ''){
            this.$api.$handler.authHeader(token);
                    if(path !== "") {
                        this.$router.push({path: path});
                    }
            this.UpdateSiteCheck();
            this.UpdateUserCheck(path);

        },

        UpdateUserCheck: function(path){

            let params = {a_container_type : 'profile'};
            this.$api.$common.getFile(params).then( res => res.Data.Result).then(res => {
                if(res.Info.status){
                    if(res.List[0]) {
                        let file = res.List[0];
                        file.url = file.thumb_url;
                        file.name = file.org_name;
                        this.$store.dispatch('common/initUserImg', {info : file} );
                    }
                }
            });

            params = {m_type : 'admin'}
            this.$api.$auth.getMember(params).then( res => res.Data.Result).then(res => {
                if(res.Info.status === true){
                    this.$store.dispatch('common/initUserInfo', {info : res.List[0]} );
                    if(path !== "") {
                        this.$router.push({path: path});
                    }
                }
            }, () => {
                this.localLogout();
            })
        },
        UpdateSiteCheck: function(){
            let params = {a_container_type : 'siteLogo'};
            this.$api.$common.getFile(params).then( res => res.Data.Result).then(res => {
                if(res.Info.status){
                    if(res.List[0]) {
                        let file = res.List[0];
                        file.url = file.thumb_url;
                        file.name = file.org_name;
                        this.$store.dispatch('common/initSiteLogo', {info : file} );
                    }
                }
            });
            this.$api.$common.getConfigInfo().then( res => res.Data.Result).then(res => {
                this.$store.dispatch('common/initSiteInfo', {info : res.List[0]} );
            })
        },
        localLogout: function(token){
            this.$localStorage.clear(true);
            this.$route.query.first = false;
            this.$router.push({path: "/auth"});
        }
    }
}
